import { User } from '@/types';

/** Perfil ADMIN ou plano Administrador (recursos de gestão no painel). */
export function canAccessAdminPanel(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'ADMIN') return true;

  const plano = user.plano;
  if (!plano) return false;

  return plano.slug === 'admin' || plano.podeGerenciarUsuarios === true;
}
